import { render, staticRenderFns } from "./XCellPlayer.vue?vue&type=template&id=0da58db4&scoped=true"
import script from "./XCellPlayer.vue?vue&type=script&lang=js"
export * from "./XCellPlayer.vue?vue&type=script&lang=js"
import style0 from "./XCellPlayer.vue?vue&type=style&index=0&id=0da58db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da58db4",
  null
  
)

export default component.exports